import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: 'genderTranslate',
  pure: false,
  standalone: false
})
export class GenderTranslatePipe implements PipeTransform {
  constructor(public translator: TranslateService) {
  }

  transform(value: any, ...args: unknown[]): unknown {
    const normalized = value?.toString().toLowerCase();
    const key = normalized === 'm' ? 'male' : normalized === 'f' ? 'female' : normalized;
    if (['male', 'female'].includes(key)) {
      return this.translator.instant('common.gender.' + key);
    }
    return value;
  }
}
